module.exports = __webpack_public_path__ + "static/media/wheel_dis_button.255b143b.png";